import { NavRoute } from '../../shared/navigation/nav.route.interface';
import { SecurityEnum } from '../security/security.enum';

/***************************************************************************************************
 * Navient Nav
 * All screens to do with data import and display should be shown here
 */
export const getNavientNav: () => NavRoute = () => {
	return {
		name: 'Portal',
		security: sec => sec?.securityAdministration?.viewSecurityReports === SecurityEnum.FullAccess,
		path: 'navient',
	};
};
